import dayjs from 'dayjs';

export class TransactionApiConverter {
  mapStatus = rawStatus => {
    switch (rawStatus) {
      case 'CREATED':
        return 'Created';
      case 'PAID':
        return 'Completed';
      case 'CANCELED':
        return 'Rejected';
      default:
        return rawStatus;
    }
  };

  convertTransfers = data =>
    data.data
      .map(v => ({
        ...v,
        type: v.amount > 0 ? 1 : 0,
      }))
      .sort((a, b) => dayjs(b.date) - dayjs(a.date));

  convertWithdrawalRequests = data => {
    return {
      items: data.data.map(v => {
        const mappedStatus = this.mapStatus(v.status);
        return {
          id: v.cashier_withdrawal_id,
          amount: v.amount,
          status: mappedStatus,
          statusName: mappedStatus,
          created_at: dayjs(v.created_at).format('DD.MM.YYYY, HH:mm'),
          user_id: v.user_id,
          user_login: v.user_login,
        };
      }),
      count: data.count,
      pages: data.pages,
    };
  };
}
